<template>
  <div class="divide-y divide-neutral-200 dark:divide-neutral-800">
    <div
      v-for="rule in sortedRules"
      :key="rule.id"
      class="py-2 px-3 hover:bg-neutral-100 dark:hover:bg-neutral-800/50 cursor-pointer"
      @click="editRule(rule)"
    >
      <div class="flex items-center gap-2">
        <code class="text-amber-600 dark:text-amber-400 text-sm">{{ rule.pattern || '(empty)' }}</code>
        <span
          v-if="rule.payee"
          class="text-neutral-600 dark:text-neutral-400 text-sm"
        >→ {{ rule.payee }}</span>
      </div>
      <div
        v-if="rule.category"
        class="text-xs text-neutral-500 dark:text-neutral-500 mt-0.5"
      >
        {{ rule.category }}
      </div>
    </div>
    <div
      v-if="!sortedRules.length"
      class="py-4 text-center text-neutral-500 text-sm"
    >
      No rules yet
    </div>
  </div>
</template>

<script>
export default {
  props: {
    app: {
      type: Object,
      required: true
    },
    from: {
      type: String,
      default: 'rules'
    }
  },

  computed: {
    rules () {
      return this.app.queries.findAllRules(this.app.identity.id)
    },

    sortedRules () {
      return [...this.rules].sort((a, b) =>
        (a.pattern || '').localeCompare(b.pattern || '', undefined, { sensitivity: 'base' })
      )
    }
  },

  methods: {
    addRule () {
      this.$router.push({
        name: 'ruleEdit',
        params: { identity_id: this.app.identity.id, rule_id: 'new' },
        query: { from: this.from }
      })
    },

    editRule (rule) {
      this.$router.push({
        name: 'ruleEdit',
        params: { identity_id: this.app.identity.id, rule_id: rule.id },
        query: { from: this.from }
      })
    }
  }
}
</script>
